import styled, { css } from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { variant } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Group } from '../../primitives/Group/Group.es.js';
import Button from '../Button/Button.es.js';

const PAGINATION_SIZE = {
  md: "36px",
  lg: "48px"
};
const sizeStyles = variant({
  prop: "buttonSize",
  variants: {
    md: {
      minWidth: PAGINATION_SIZE.md,
      height: PAGINATION_SIZE.md,
      fontSize: "md",
      lineHeight: PAGINATION_SIZE.md
    },
    lg: {
      minWidth: PAGINATION_SIZE.lg,
      height: PAGINATION_SIZE.lg,
      fontSize: "lg",
      lineHeight: PAGINATION_SIZE.lg
    }
  }
});
const shapeStyles = variant({
  prop: "shape",
  variants: {
    default: {
      borderRadius: "sm"
    },
    round: {
      borderRadius: "round"
    }
  }
});
const PaginationPageButton = styled(Button)`
    padding: 0;

    ${sizeStyles};
    ${shapeStyles};

    ${({ onClick }) => !onClick && css`
            pointer-events: none;
        `}
`;
const PaginationComponent = styled(Group)`
    display: flex;
    align-items: center;
    justify-content: start;
`;

export { PaginationComponent, PaginationPageButton };
//# sourceMappingURL=styled.es.js.map
